import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Typography, useTheme } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux'

import imgBiometrics from '../../assets/biometrics_help.png'
import { GenericContainer, Buttons } from '../../components'
import { workflowActions, fileActions } from '../../store/actions'
import { coreFunctions,ApiFatechUrl } from '../../utils'
import { useStyles } from './BiometricsStyles';
import { useTranslation } from 'react-i18next';

export default function BiometricsHelp(props) {
    const [enrollActive, setEnrollActive] = useState(true)
    const [continueActive, setContinueActive] = useState(false)
    const localStyles = useStyles()
    const navigate = useNavigate()
    //Redux hooks
    const auth = useSelector(state => state.Authentication)
    const continueWf = useSelector(state => state.ContinueWorkflow)
    const file = useSelector(state => state.FileInfo)
    const dispatch = useDispatch();
    const { t } = useTranslation();

    let fileId;

    useEffect(() => {
        dispatch(fileActions.GetFileInfo(auth.items.UserLoginData.CurrentFileId));
    }, [])

    useEffect(() => {
        if (file.items != undefined) {
            console.log("FILE:::: ", file)
            fileId = file.items.Id
        }
    }, [file])

    let openFaceTec = (fileId) => {
        if (enrollActive) {
            window.open(`${ApiFatechUrl.ambient}?fileId=${fileId}`)
            setEnrollActive(false)
            setContinueActive(true)
        } else {
            return
        }
    }

    let goToNextComponent = () => {
        if (continueActive) {
            sessionStorage.setItem('biometricProcess', 1)
            let data = { 'File_Id': fileId }
            dispatch(workflowActions.ContinueWorkflowAction(data))
        } else {
            return
        }
    }

    useEffect(() => {
        if (continueWf.items != undefined && continueActive) {
            let nextStage = continueWf.items.Stage
            let stageName = nextStage.Name
            let stageId = nextStage.Id
            let stage = continueWf.items
            let nextComponent = coreFunctions.GetLegoNext(stageName)
            let biometricProcess = sessionStorage.getItem('biometricProcess')
            if (biometricProcess == 1) {
                sessionStorage.setItem('biometricProcess', 0)
            }
            coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage } })
        }
    }, [continueWf])

    return (<GenericContainer>
        <Typography
          variant="body1"
          className={localStyles.title}
        >
          {t("applicant_biometrics")}
        </Typography>
        <Typography
            variant="subtitle2"
             >
            {t("applicant_biometrics_instructions")}
        </Typography>
        <img src={imgBiometrics} className={localStyles.devicePic} alt="ineDevice" />
        <Buttons ConfirmButtonText={t("capture_selfie")}
            onClickConfirm={openFaceTec} />
    </GenericContainer>)
}